import script from "./UniversalScreenersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UniversalScreenersModal.vue?vue&type=script&setup=true&lang=ts"

import "./UniversalScreenersModal.vue?vue&type=style&index=0&id=5e9da0a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9da0a0"]])

export default __exports__